/*
Important
This file is used only for the vue2 application.
Changes made here will not be reflected in the Vue3 application.
You need to make changes in the vue3 file also
Vue3 file: wwwroot\js\mixins\LazyLoadScrollComponent.js
Any clarifications contact Laxman Directly
*/
import { ref, onMounted, onUnmounted } from 'vue';

export function useLazyLoadComponent() {
  const lazyLoadComponent = ref(false);

  const getDocHeight = () => {
    const D = document;
    return Math.max(
      D.body.scrollHeight,
      D.documentElement.scrollHeight,
      D.body.offsetHeight,
      D.documentElement.offsetHeight,
      D.body.clientHeight,
      D.documentElement.clientHeight
    );
  };

  const handleScroll = () => {
    const winHeight =
      window.innerHeight || (document.documentElement || document.body).clientHeight;
    const docHeight = getDocHeight();
    const scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const trackLength = docHeight - winHeight;
    const pctScrolled = Math.floor((scrollTop / trackLength) * 100);

    if (pctScrolled >= 20 && !lazyLoadComponent.value) {
      lazyLoadComponent.value = true;
    }
  };

  onMounted(() => {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        window.addEventListener('scroll', handleScroll, { passive: true });
      },
      false
    );
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {
    lazyLoadComponent,
  };
}
